import { AllServicesContent } from "./all-services-content";
import { MobileFullscreenModal } from "@/components/shared/mobile-fullscreen-modal";
import { SearchInput } from "@/components/shared/search-input";
import { useSearchStore } from "@/store/search-bar";
import { useState } from "react";

export function AllServicesModal({
  modalOpen,
  handleOpenChange,
  autoFocus = false,
}: {
  modalOpen: boolean;
  handleOpenChange(newState: boolean): void;
  autoFocus?: boolean;
}) {
  const { isOnSearch } = useSearchStore();
  const [query, setQuery] = useState("");
  return (
    <MobileFullscreenModal
      contentWrapperClassName="p-0 no-scrollbar"
      open={modalOpen}
      className="w-screen bg-white"
      onClose={() => handleOpenChange(false)}
      title="All Luce Services"
    >
      <SearchInput autoFocus={autoFocus} value={query} onChange={setQuery} />
      {!isOnSearch && <AllServicesContent query={query} />}
    </MobileFullscreenModal>
  );
}
